import { OrganizationDataLpController } from './organization-data-lp.controller';

export const OrganizationDataLpComponent: ng.IComponentOptions = {
    template: require('./organization-data-lp.html'),
    controller: OrganizationDataLpController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/organization-data-lp/organization-data-lp.component.ts